import {
  Dimensions,
  Modal,
  StyleProp,
  StyleSheet,
  View,
  ViewStyle,
} from 'react-native';
import { Colors } from '../../../themes/colors';
import { EditAlertForm } from './editAlertForm';

type EditAlertModalProps = {
  editAlertModalVisible: boolean;
  editAlertModalStyle: StyleProp<ViewStyle>;
  onClose: () => void;
  alertId: string;
  routineId: string;
  workspaceAssetId: string;
  productId?: string;
  groupId?: string;
};

export const EditAlertModal = ({
  editAlertModalVisible,
  editAlertModalStyle,
  onClose,
  alertId,
  routineId,
  workspaceAssetId,
  productId,
  groupId,
}: EditAlertModalProps) => {
  return (
    <Modal
      visible={editAlertModalVisible}
      transparent={true}
      onRequestClose={onClose}
    >
      <View style={editAlertModalStyle}>
        <View style={styles.modalContainer}>
          <EditAlertForm
            alertId={alertId}
            routineId={routineId}
            workspaceAssetId={workspaceAssetId}
            onClose={onClose}
            productId={productId}
            groupId={groupId}
          />
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  webModalBackground: {
    flex: 1,
    backgroundColor: Colors.role.inverseDim,
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContainer: {
    width: '100%',
    maxWidth: 560,
    minHeight: 461,
    maxHeight: Dimensions.get('window').height * 0.65,
    backgroundColor: Colors.role.surfaceHover,
    borderRadius: 12,
    overflow: 'hidden',
    elevation: 10,
  },
});
